export default function hasObj(obj, strProps) {   
    const props = strProps.split('.');
    for (let i = 0, l=props.length; i < l; i++) {
      if (!obj || !obj.hasOwnProperty(props[i])) {
        return false;
      }
      obj = obj[props[i]];
    }
    return true;
  }


// WEBPACK FOOTER //
// ./app/lib/util/hasObj.js